export default "__VITE_ASSET__d5b13148__$_?nuxt_component=async__"